import { render, staticRenderFns } from "./handOver.vue?vue&type=template&id=5129d551"
import script from "./handOver.vue?vue&type=script&lang=js"
export * from "./handOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports